module.exports = __webpack_public_path__ + "media/images/icons/social-yelp-fdbaa6df61c4884c88e8c1df32cea098.svg";